import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Step1Selector from './components/Step1Selector';
import Step2ConfigurationList from './components/Step2ConfigurationList';
import Step3ProductTable from './components/Step3ProductTable';
import Step4ProductList from './components/Step4ProductList';

function App() {

    const stepFromURL = () => {
  const hash = window.location.hash;            // #step-3
  if (hash.startsWith('#step-')) {
    const n = Number(hash.replace('#step-', ''));
    if (n >= 1 && n <= 4) return n;
  }
  return 1;                                     // default
};

const pushStep = (step) => {
  window.history.pushState({ step }, '', `#step-${step}`);
};

  const [step, setStep] = useState(stepFromURL());

const go = (next) => {
  setStep(next);
  pushStep(next);
};

  /* =================================================
   * 5. push first history entry on mount
   * ================================================= */
  React.useEffect(() => {
    pushStep(step);          // writes #step-1 (or 2,3,4) once
  }, []);                    // empty deps → run only once

  /* =================================================
   * 4. listen for Back / Forward buttons
   * ================================================= */
  React.useEffect(() => {
    const onPop = (e) => {
      if (e.state?.step) setStep(e.state.step);   // normal nav
      else               setStep(stepFromURL());  // hash typed manually
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);  

  const [formData, setFormData] = useState({
    wallWidth: 0,
    sinkCount: 1,
    selectedConfig: null,
    products: [],
    selectedVariant: null,
    vanityPlacement: 'Floating' // NEW
  });

  const handleStep1Next = (data) => {
    setFormData(prev => ({ ...prev, ...data }));
    go(2);
  };

  const handleSelectConfiguration = (config) => {
    setFormData(prev => ({ ...prev, selectedConfig: config }));
    go(3);
  };

  const handleStep3Next = (products, selectedVariant) => {
    setFormData(prev => ({ ...prev, products, selectedVariant }));
    go(4);
  };

  const handleRestart = () => {
    setFormData({
      wallWidth: 60,
      sinkCount: 1,
      selectedConfig: null,
      products: [],
      selectedVariant: null,
      vanityPlacement: 'Floating'
    });
    go(1);
  };

  /* … imports … */
const stepLabels = [
  'Wall Width',        // 1
  'Configurations',    // 2
  'Style & Finish',    // 3
  'Product List'       // 4
];


  // const handleBack = () => setStep(prev => Math.max(1, prev - 1));

  const handleBack = () => go(Math.max(1, step - 1));

  const getProgress = () => (step / 4) * 100;

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1Selector onNext={handleStep1Next} defaultValues={formData} />;
      case 2:
        return (
          <Step2ConfigurationList
            wallWidth={formData.wallWidth}
            sinkCount={formData.sinkCount}
            onSelectConfiguration={handleSelectConfiguration}
            onBack={handleBack}
          />
        );
      case 3:
        return formData.selectedConfig ? (
          <Step3ProductTable
            selectedConfig={formData.selectedConfig}
            onBack={handleBack}
            onNext={handleStep3Next}
          />
        ) : (
          <div className="text-center">No configuration selected.</div>
        );
      case 4:
        return (
          <Step4ProductList
            wallWidth={formData.wallWidth}
            products={formData.products}
            vanityPlacement={formData.vanityPlacement} // ✅ PASSED
            selectedVariant={formData.selectedVariant}
            selectedVariantSlug={formData.selectedVariant?.slug} // ✅ PASSED
            onBack={() => go(3)}
            onRestart={handleRestart}
          />
        );
      default:
        return null;
    }
  };

  return (

    <div>
      
        <header>
          <div class="logo">
            <a href="https://hamptonbaykitchens.com">
              <svg width="426" height="44" viewBox="0 0 426 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_13_14)">
                  <path d="M26.72 42.4C26.78 41.51 27.14 40.08 27.37 39.25C28.44 38.95 30.28 38.6 31.53 38.48V22.86H10.81V38.54C12 38.6 14.37 38.78 15.74 39.07C15.98 39.78 16.04 41.74 15.92 42.4H0C0.06 41.51 0.42 40.08 0.71 39.25C1.78 38.95 4.03 38.6 5.34 38.48V4.99C3.97 4.93 1.95 4.75 0.94 4.57C0.76 3.8 0.7 1.96 0.82 1.18H15.61C15.79 1.89 15.73 3.73 15.49 4.51C14.24 4.75 12.28 4.93 10.8 4.98V19H31.52V4.99C30.15 4.93 28.14 4.75 27.13 4.57C26.95 3.8 26.89 1.96 27.01 1.18H41.97C42.15 1.89 42.09 3.73 41.85 4.51C40.54 4.75 38.52 4.93 36.98 4.98V38.53C38.7 38.65 40.78 38.83 42.27 39.12C42.45 39.77 42.51 40.6 42.51 41.44C42.51 41.8 42.51 41.98 42.45 42.39H26.71L26.72 42.4Z" fill="white">
                  </path>
                  <path d="M73.58 42.4C73.7 41.45 74 40.14 74.35 39.25C75.36 38.95 77.5 38.66 78.75 38.54C77.8 37.17 77.03 35.51 76.43 33.97L74.53 28.92H58.79L56.83 34.26C56.29 35.8 55.46 37.41 54.69 38.72C56.12 38.78 58.13 38.96 59.68 39.25C59.92 40.02 60.16 41.68 60.16 42.4H46.03C46.15 41.39 46.57 40.08 46.98 39.25C47.81 38.95 49.18 38.72 50.13 38.6L65.45 0.360001H69.25L83.98 38.49C84.93 38.55 86.71 38.79 87.72 39.02C88.02 39.91 88.31 41.4 88.37 42.41H73.58V42.4ZM66.45 7.01C66.21 8.38 65.38 11.17 64.79 12.71L60.04 25.54H73.22L68.35 12.59C67.82 11.17 67.04 8.43 66.87 7.01H66.45Z" fill="white">
                  </path>
                  <path d="M104.7 17.22C103.16 12.94 101.85 8.79 101.37 5.11H100.95V38.66C102.32 38.78 103.92 38.96 105.11 39.25C105.29 39.9 105.35 41.68 105.23 42.4H91.93C91.99 41.51 92.29 40.26 92.58 39.37C93.59 39.07 95.61 38.72 96.8 38.6V4.99C95.43 4.93 93.47 4.75 92.46 4.58C92.28 3.81 92.22 1.91 92.34 1.19H104.63L113.42 26.31C114.55 29.52 115.68 33.2 116.21 36.47H116.63C117.28 33.2 118.41 29.52 119.6 26.31L128.69 1.19H140.8C140.98 1.9 140.92 3.74 140.68 4.52C139.37 4.76 137.41 4.94 135.87 4.99V38.54C137.59 38.66 139.67 38.84 141.16 39.13C141.34 39.78 141.4 40.61 141.4 41.45C141.4 41.81 141.4 41.98 141.34 42.4H125.72C125.78 41.51 126.14 40.08 126.37 39.25C127.38 38.95 129.52 38.6 130.71 38.48V5.11H130.29C129.81 8.61 128.39 13.19 126.85 17.34L117.41 43.17H114.02L104.7 17.22Z" fill="white">
                  </path>
                  <path d="M151.02 5.05C149.65 5.05 147.87 5.05 146.63 4.87C146.45 4.1 146.39 2.14 146.51 1.25C151.68 0.77 156.9 0.6 161.65 0.6C170.38 0.6 177.03 4.7 177.03 12.95C177.03 22.04 170.08 26.02 163.07 26.02C160.99 26.02 158.68 25.84 156.48 25.55V38.56C158.56 38.68 161.05 38.86 162.89 39.15C163.13 39.86 163.19 41.76 163.07 42.42H145.67C145.73 41.53 146.09 40.1 146.38 39.27C147.45 38.97 149.71 38.62 151.01 38.5V5.05H151.02ZM156.49 22.03C158.39 22.21 160.76 22.33 162.84 22.33C168.24 22.33 171.39 19.72 171.39 13.24C171.39 7.42 167.06 4.33 160.82 4.33C159.69 4.33 157.55 4.45 156.48 4.57V22.03H156.49Z" fill="white">
                  </path>
                  <path d="M200.97 38.54C202.81 38.66 205.07 38.84 206.67 39.13C206.91 39.84 206.97 41.68 206.85 42.4H189.75C189.81 41.51 190.23 40.08 190.52 39.25C191.71 38.95 194.08 38.6 195.51 38.48V4.81H185.89C185.77 6.18 185.36 8.79 185.12 9.86C184.23 10.1 182.63 10.22 181.56 10.22V1.19H214.94V10.45C213.75 10.45 212.27 10.27 211.32 10.04C211.02 8.73 210.67 6.3 210.55 4.81H200.99V38.54H200.97Z" fill="white">
                  </path>
                  <path d="M256.08 21.2C256.08 35.45 248.71 43.59 237.43 43.59C225.32 43.59 218.6 35.87 218.6 21.2C218.6 8.08 226.68 0 237.43 0C248.18 0 256.08 7.54 256.08 21.2ZM237.43 39.61C245.98 39.61 250.2 32.6 250.2 21.2C250.2 11.22 245.15 3.92 237.43 3.92C228.94 3.92 224.48 10.75 224.48 21.2C224.48 32.36 229.23 39.61 237.43 39.61Z" fill="white">
                  </path>
                  <path d="M287.97 28.68C288.98 30.52 291 35.27 291.47 37.29H291.89V4.99C290.52 4.93 288.44 4.75 287.44 4.58C287.26 3.81 287.2 1.91 287.32 1.19H300.44C300.5 1.43 300.56 1.9 300.56 2.44C300.56 3.27 300.44 4.04 300.32 4.52C299.19 4.76 297.47 4.94 296.1 4.99V42.76H289.39L272.05 10.39C271.46 9.32 270.56 7.48 269.97 6.06H269.55V38.54C271.21 38.66 273.29 38.84 274.72 39.13C274.96 39.84 275.02 41.68 274.9 42.4H259.82C259.88 41.51 260.24 40.08 260.53 39.25C261.54 38.95 263.8 38.6 265.04 38.48V4.99C263.67 4.93 261.65 4.75 260.65 4.58C260.47 3.81 260.41 1.91 260.53 1.19H273.06L287.97 28.68Z" fill="white">
                  </path>
                  <path d="M342.78 20.61C348.3 21.74 351.92 25.06 351.92 30.29C351.92 39.14 344.08 42.58 335.77 42.58C330.13 42.58 323.6 42.46 318.67 42.28C318.73 41.39 319.09 39.9 319.38 39.07C320.39 38.77 322.71 38.42 324.01 38.3V4.75C322.64 4.75 321.04 4.75 319.61 4.57C319.43 3.8 319.37 1.78 319.49 1.01C324.42 0.710001 329.47 0.540001 334.04 0.540001C342.71 0.540001 349.72 4.1 349.72 11.35C349.72 15.8 346.87 19.25 342.77 20.32V20.62L342.78 20.61ZM329.48 19H335.06C340.88 19 344.26 16.98 344.26 11.52C344.26 6.71 339.63 4.16 333.39 4.16C332.44 4.16 330.72 4.16 329.47 4.28V19.01L329.48 19ZM329.48 38.66C331.26 38.84 333.22 38.9 335 38.9C342.01 38.9 346.28 36.47 346.28 30.76C346.28 25.05 341.59 22.62 335.29 22.62H329.47V38.65L329.48 38.66Z" fill="white">
                  </path>
                  <path d="M379.84 42.4C379.96 41.45 380.26 40.14 380.61 39.25C381.62 38.95 383.76 38.66 385 38.54C384.05 37.17 383.28 35.51 382.68 33.97L380.78 28.92H365.04L363.08 34.26C362.55 35.8 361.72 37.41 360.94 38.72C362.37 38.78 364.39 38.96 365.93 39.25C366.17 40.02 366.4 41.68 366.4 42.4H352.27C352.39 41.39 352.8 40.08 353.22 39.25C354.05 38.95 355.42 38.72 356.37 38.6L371.7 0.360001H375.5L390.23 38.49C391.18 38.55 392.96 38.79 393.97 39.02C394.27 39.91 394.56 41.4 394.62 42.41H379.83L379.84 42.4ZM372.71 7.01C372.47 8.38 371.64 11.17 371.05 12.71L366.3 25.54H379.48L374.61 12.59C374.08 11.17 373.3 8.43 373.13 7.01H372.71Z" fill="white">
                  </path>
                  <path d="M408.23 22.33C408.53 21.32 409.12 19.9 409.71 18.77L414.76 9.09C415.41 7.84 416.36 6.18 417.31 4.99C416.06 4.93 414.4 4.75 413.33 4.52C412.97 3.51 412.79 2.09 412.79 1.19H425.02C425.02 2.02 424.84 3.68 424.61 4.58C423.78 4.76 422.65 4.88 421.76 4.94L409.76 26.14V38.55C411.6 38.67 413.8 38.85 415.4 39.14C415.64 39.85 415.7 41.75 415.58 42.41H398.48C398.6 41.46 398.95 40.03 399.25 39.26C400.44 38.96 402.87 38.61 404.3 38.49V26.26L393.55 5.12C392.66 5.06 391.23 4.82 390.34 4.59C390.04 3.76 389.8 2.1 389.8 1.2H404.71C404.71 2.21 404.47 3.69 404.17 4.53C402.81 4.77 400.9 4.95 399.3 5C400.31 6.31 401.14 7.67 401.79 9.04L406.54 18.78C407.02 19.79 407.55 21.39 407.79 22.34H408.21L408.23 22.33Z" fill="white">
                  </path>
                  <path d="M419.92 42.39C418.15 42.39 416.96 41.16 416.96 39.42C416.96 37.68 418.19 36.45 419.96 36.45C421.73 36.45 422.92 37.68 422.92 39.41C422.92 41.14 421.68 42.39 419.92 42.39ZM419.93 36.93C418.47 36.93 417.51 38.01 417.51 39.41C417.51 40.81 418.47 41.93 419.94 41.93C421.41 41.93 422.36 40.86 422.36 39.44C422.36 38.02 421.4 36.93 419.93 36.93ZM419 38.22C418.87 38.22 418.63 38.21 418.55 38.19C418.52 38.12 418.51 37.94 418.53 37.84C418.95 37.81 419.51 37.8 419.89 37.8C420.67 37.8 421.25 38.07 421.25 38.68C421.25 39.15 420.93 39.46 420.53 39.54C420.71 39.89 420.95 40.28 421.15 40.56L421.56 40.52C421.56 40.63 421.52 40.8 421.46 40.89C421.26 40.95 421.05 40.97 420.81 40.99C420.55 40.61 420.26 40.07 420.03 39.62C419.85 39.62 419.65 39.61 419.51 39.59V40.54C419.67 40.55 419.88 40.6 419.98 40.62C419.99 40.69 420.01 40.83 419.99 40.92H418.48C418.49 40.82 418.54 40.68 418.57 40.62C418.7 40.58 418.95 40.54 419.01 40.54V38.23L419 38.22ZM420 39.26C420.42 39.26 420.72 39.06 420.72 38.69C420.72 38.29 420.35 38.14 419.81 38.14C419.72 38.14 419.61 38.14 419.5 38.15V39.23C419.64 39.26 419.83 39.26 419.99 39.26" fill="white">
                  </path>
                </g>
                <defs>
                  <clipPath id="clip0_13_14">
                    <rect width="425.03" height="43.59" fill="white">
                    </rect>
                  </clipPath>
                </defs>
              </svg>
            </a>
            <div class="site-name">Vanity Builder</div></div></header>




<ul className="progress-tracker">
  {stepLabels.map((label, i) => {
    const s   = i + 1;                         // step number 1-4
    const cls =
      s === step      ? 'active' :             // current step
      s <  step       ? 'completed' : '';      // done steps

    return (
      <li key={s} className={cls} data-step={s}>
        {label}
      </li>
    );
  })}
</ul>

        {renderStep()}
    
    </div>
  );
}

export default App;
